<template>
  <div class="tabs-container">
    <div class="tabs-wrapper">
      <div class="tab" id="messages-tab" :class="activeTab === 'messages' ? 'tab-active' : ''" @click="() => navigate('Messages')">
        Messages
      </div>
      <div class="tab" id="ab-tests-tab" :class="activeTab === 'ab-tests' ? 'tab-active' : ''" @click="() => navigate('ABTests')">
        A/B Tests
      </div>
      <div class="tab" id="automated-tab" :class="activeTab === 'automated-messages' ? 'tab-active' : ''" @click="() => navigate('AutomatedMessages')">
        Automated Messages
      </div>
      <div class="tab" id="automated-tab" :class="activeTab === 'automated-ab-tests' ? 'tab-active' : ''" @click="() => navigate('AutomatedABTests')">
        Automated A/B Tests
      </div>
      <div class="vl"></div>
      <div class="tab" id="template-tab" :class="activeTab === 'templates' ? 'tab-active' : ''" @click="() => navigate('Templates')">
        Templates
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  computed: {
    activeTab() {
      return this.$route.path.split('/').slice(-1)[0]
    }
  },
  methods: {
    navigate(tab) {
      this.$router.push({name: 'Messages' + tab})
    }
  }
}
</script>

<style scoped>
.tabs-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs-wrapper {
  background-color: rgba(25, 25, 38, 0.83);
  border-radius: 5px;
  padding: 5px 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tab {
  color: #778CA3;
  font-size: 15px;
  line-height: 28px;
  padding: 10px;
  margin: 10px 0;
  cursor: pointer;
}

.tab-active {
  color: #03B3DA;
  text-decoration: underline;
  pointer-events: none;
  cursor: default;
}
</style>